import {
  object,
  string,
  nativeEnum,
  number,
  discriminatedUnion,
  literal,
  any as zodAny,
} from 'zod';

// eslint-disable-next-line @nx/enforce-module-boundaries
import { IS_REQUIRED } from '@occc-app/lib/constants/validationMessages';
import { Constraint_Purchase_Threshold_Counting_Attribute } from '@occc/graphql';

export const qualifyingEventConfigurationFormSchema = discriminatedUnion('type', [
  object({
    type: literal('loyaltyEvent'),
    loyaltyEventOffer: object({ id: string(), name: string() }, { message: IS_REQUIRED }),
    transaction: zodAny().transform(() => null),
  }),
  object({
    type: literal('transaction'),
    transaction: object({
      productGroups: object({ id: string(), name: string() })
        .array()
        .min(1, { message: IS_REQUIRED }), // Eligible product groups
      countProductsBy: nativeEnum(Constraint_Purchase_Threshold_Counting_Attribute),
      purchaseThreshold: number({ required_error: IS_REQUIRED }).min(1).int().positive(),
    }),
    loyaltyEventOffer: zodAny().transform(() => null),
  }),
]);
